export enum ModalSubTitleType {
  ORGANIZATION = "ORGANIZATION",
  PARTICIPANT = "PARTICIPANT",
  CUSTOM = "CUSTOM",
  DATETIME = "DATETIME",
  LOCATION = "LOCATION"
}
